import React, { Component } from 'react'
import * as Sentry from '@sentry/browser'
import { isAndroid } from 'react-device-detect'
import SmartBanner from 'react-smartbanner'
import MetaAppleApp from 'components/shared/meta_apple_app'
import { shoudShowGoogleBanner, shoudShowAppleBanner } from 'components/dashboard/shared/util'

// I18n
import { IntlProvider, injectIntl } from 'react-intl'
if (!global.Intl) require('intl') // old browsers

// Components
import Toolbar from './layout/toolbar'
import Sidebar from './layout/sidebar'

Sentry.init({
  dsn: window.sentryDSN,
})

class Layout extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      sidebarExpanded: false
    }
  }

  onSidebarExpand() {
    this.setState((prevState) => ({ sidebarExpanded: !prevState.sidebarExpanded }))
  }

  render() {
    const mainClass = this.state.sidebarExpanded ? 'layout__sidebar-expanded' : ''
    const currentYear = (new Date()).getFullYear()

    return (
      <IntlProvider locale={this.props.intlLocale} messages={this.props.messages}>
        <div>
          {shoudShowAppleBanner(this.props) && <MetaAppleApp />}
          {isAndroid && shoudShowGoogleBanner(this.props) && <SmartBanner title={'MTX Connect'} />}

          <Toolbar
            intl={this.props.intl}
            locale={this.props.locale}
            region={this.props.region}
            resources={this.props.resources}
            onSidebarExpand={this.onSidebarExpand.bind(this)} />

          <main className={`layout ${mainClass}`}>
            <Sidebar
              intl={this.props.intl}
              locale={this.props.locale}
              region={this.props.region}
              resources={this.props.resources}
              currentPath={this.props.currentPath} />

            <div className="layout-content-wrapper">
              <article className="layout-content">
                {this.props.flash &&
                  <div className={`flash flash-${this.props.flash.type}`}>
                    {this.props.flash.message}
                  </div>
                }
                {this.props.children}
              </article>

              <footer className="layout-content-footer">
                © {currentYear} <span className='brand-name'>MTX Connect</span>
              </footer>
            </div>
          </main>
        </div>
      </IntlProvider>
    )
  }
}

export default injectIntl(Layout)



// WEBPACK FOOTER //
// ./app/javascript/components/application/layout.js